import React, {useEffect} from 'react';
import { Breadcrumb, BackdropCircular } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import {
  getBookNowButtonConfigApi,
  saveBookNowButtonConfigApi
} from 'api/others';
import { Formik } from 'formik';
import {
  Card,
  Divider,
  Typography,
  Switch,
  Grid,
  Button,
  TextField
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
  title: {
    color: '#001239',
    fontSize: '20px',
  }
});


const BookNowButtonConfig = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {isBookNowEnabled, isBookNowOnNewWindow, bookNowLink, isLoading} = useSelector((state) => state.buttons_configs.bookNowConfigs);

  useEffect(() => {
    getBookNowButtonConfigApi({dispatch});
  }, []);

  const handleSave = (values) => {
    const configs = [
      {
        path: 'theme_design/header_primary/is_cta_left_link_enabled',
        value: values.isEnabled
      },
      {
        path: 'theme_design/header_primary/cta_left_link_title',
        value: 'book now'
      },
      {
        path: 'theme_design/header_primary/is_cta_left_link_external',
        value: values.isOnNewWindow
      },
      {
        path: 'theme_design/header_primary/cta_left_link',
        value: values.redirectLink
      }
    ];

    saveBookNowButtonConfigApi({dispatch, configs});
  };

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div>
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'UI Configurations', path: '/settings#UI_configurations' },
            { name: 'Book Now Button' }
          ]}
        />
      </div>
      <div className="m-10">
        <Card elevation={25} className="p-8">
          <Typography className={`${classes.title} mb-5`} variant="h6">Book Now Button</Typography>
          <Divider />
          <Formik
            initialValues={{
              isEnabled: isBookNowEnabled,
              isOnNewWindow: isBookNowOnNewWindow,
              redirectLink: bookNowLink
            }}
            enableReinitialize
            onSubmit={(values) => handleSave(values)}
          >
            {({
              values,
              handleBlur,
              handleSubmit,
              setFieldValue,
              handleChange
            }) => (
              <form onSubmit={handleSubmit}>
                <Grid container spacing={3} className="mt-2 ml-2 flex items-center">
                  <Grid item xs={12} sm={4} md={2}>Enable</Grid>
                  <Grid item xs={12} sm={8} md={10}>
                    <Switch
                      color="primary"
                      name="isEnabled"
                      checked={values.isEnabled == '1'}
                      value={values.isEnabled}
                      onChange={() => setFieldValue('isEnabled', values.isEnabled == '1' ? '0' : '1')}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3} className="mt-2 ml-2 flex items-center">
                  <Grid item xs={12} sm={4} md={2}>Open In New Window</Grid>
                  <Grid item xs={12} sm={8} md={10}>
                    <Switch
                      color="primary"
                      name="isOnNewWindow"
                      value={values.isOnNewWindow}
                      checked={values.isOnNewWindow == '1'}
                      onChange={() => setFieldValue('isOnNewWindow', values.isOnNewWindow == '1' ? '0' : '1')}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3} className="mt-2 ml-2 flex items-center">
                  <Grid item xs={12} sm={4} md={2}>Book Now Button Link</Grid>
                  <Grid item xs={12} sm={5} md={5}>
                    <TextField
                      className="w-full"
                      label="https://"
                      variant="outlined"
                      name="redirectLink"
                      value={values.redirectLink}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>
                </Grid>
                <div className="text-right mt-10">
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                  >
                    Save Configurations
                  </Button>
                  <BackdropCircular loading={isLoading} />
                </div>
              </form>
            )}
          </Formik>
        </Card>
      </div>
    </div>
  );
};

export default BookNowButtonConfig;
